import { IDeviationBasket } from "@chef/state-management";
import { useLoyalty } from "@chef/state-management/hooks";
import { useCalendarData } from "@chef/state-management/hooks";
import { isMealboxBasketType } from "@chef/helpers";

import { useFinancesForDeviation } from "./useFinancesForDeviation";
import { DeliveryFee } from "../shared/DeliveryFee";

interface DeviationDeliveryProps {
  deviation: IDeviationBasket;
}

export const DeviationDelivery = ({ deviation }: DeviationDeliveryProps) => {
  const { data: loyaltyData } = useLoyalty();
  const { finances } = useFinancesForDeviation({ deviation });
  const { calendar } = useCalendarData({
    week: deviation.week,
    year: deviation.year,
    range: 1,
  });

  if (!loyaltyData) {
    return null;
  }

  const weekCalendar = calendar?.find(
    (w) => w.week === deviation.week && w.year === deviation.year,
  );

  const deliveryFee = weekCalendar?.baskets.find((basket) =>
    isMealboxBasketType(basket),
  )?.shippingDetails.plannedDeliveryInformation.customerFee;

  return (
    <DeliveryFee
      customerFee={deliveryFee ?? finances.customerFee}
      hasFreeShipping={loyaltyData.currentLevel === 4}
    />
  );
};
